import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import img from '../../../images/back-to-top.svg';

export const BackToTopWrapper = styled.div`
  text-align: center;
  &.visible {
    height: auto;
    min-height: 130px;
    .buttonTop {
      right: 0;
    }
  }

  .buttonTop {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: fixed;
    transition: all 0.5s;
    background-color: ${themeGet('colors.white')};
    border-radius: 0 0.3rem 0.3rem 0;
    box-shadow: 0 0.1rem 0.5rem 0 rgba(0, 0, 0, 0.2);
    bottom: 15.5%;
    z-index: 500;
    /* Left -(size of button) to hide it completely off screen */
    left: -95px;
    width: 3rem;
    padding: 0.5rem;

    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
      width: 4rem;
      padding: 0.75rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-bottom: 0.25rem;
      bottom: 25%;
      width: 5.625rem;
    }

    &:hover {
      background-color: ${themeGet('colors.light-grey')};
      p {
        color: ${themeGet('colors.main-text')};
      }
    }

    p {
      color: ${themeGet('colors.main-text')};
      clear: both;
      text-align: center;
      position: relative;
      padding: 0;
      margin-bottom: 0;
      transition: all 0.5s;
      font-size: 1rem;

      @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
        clip: rect(0px, 0px, 0px, 0px);
        clip-path: inset(50%);
        height: 1px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        width: 1px;
      }
    }
  }

  .buttonTopAnimate {
    left: 0;
  }
`;

export const BackgroundImage = styled.div`
  background-image: url(${img});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 2rem;
  width: 2rem;

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    height: 2.5rem;
    width: 2.5rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 0.25rem;
  }
`;
